import React from "react"

import isBrowser from "../utils/isBrowser"

const isGoogleTagManagerDataLayerAvailable = () => isBrowser() && !!window["dataLayer"]

export * from "@secureo/common/typings/EnhancedEcommerce"
export * from "@secureo/common/typings/GoogleAnalytics4Ecommerce"

export const pushEventToDataLayer = (event: any) => {
	if (isGoogleTagManagerDataLayerAvailable()) window["dataLayer"].push(event)
}

export const GoogleTagManagerScript = ({ containerId }: Props) => {
	if (!containerId) return null

	return (
		<script
			type="text/javascript"
			dangerouslySetInnerHTML={{
				__html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${containerId}')`,
			}}
		/>
	)
}

export const GoogleTagManagerIframe = ({ containerId }: Props) => {
	if (!containerId) return null

	return (
		<noscript>
			<iframe
				title="GTM"
				src={`https://www.googletagmanager.com/ns.html?id=${containerId}`}
				height="0"
				width="0"
				style={{ display: "none", visibility: "hidden" }}
			></iframe>
		</noscript>
	)
}

interface Props {
	containerId: string
}
